import { Component, OnInit } from '@angular/core';
import { APP_MODEL_DATA } from 'src/app/model-data/app-model-data';
import { MainService } from 'src/app/services/main.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
    selector: 'app-access-restricted',
    templateUrl: './access-restricted.component.html',
    styleUrls: ['./access-restricted.component.css'],
    standalone: false
})
export class AccessRestrictedComponent implements OnInit {

  constructor( public utilService: UtilService,
    public mainService: MainService,) { }

  ngOnInit(): void {
    this.utilService.showNavigationBar.next(false);

  }

  signOut() {
    this.utilService.showSpinner(APP_MODEL_DATA.APP_SPINNER);
    this.mainService.gSuiteSignOut().subscribe({
      next: () => {
        this.utilService.hideSpinner(APP_MODEL_DATA.APP_SPINNER);
        this.utilService.signout()
      }
    });
  }

}
